<div class="border-standard py-2 px-4 flex justify-between items-center text-primary-gray text-base">
  <input
    type="text"
    class="form-control"
    ngxDaterangepickerMd
    [ranges]="ranges"
    [opens]="'left'"
    [locale]="locale"
    [showClearButton]="false"
    [showDropdowns]="true"
    [showCancel]="false"
    [linkedCalendars]="false"
    [showCustomRangeLabel]="true"
    [alwaysShowCalendars]="true"
    [autoApply]="true"
    [(ngModel)]="selected"
    (datesUpdated)="onDatesUpdated($event)"
    [placeholder]="placeholder"
    class="date-range-input"
  />
  <i class="fa-solid fa-calendar"></i>
</div>
